import { ActionIcon, Menu, Tooltip, useMantineColorScheme } from "@mantine/core";

import { IconFilter, IconFilterFilled } from "@/components/icons";

import type { ActionIconProps } from "@mantine/core";
import type { IconProps } from "@tabler/icons-react";
import type { FC, PropsWithChildren } from "react";

export type ListTableColumnFilterProps = PropsWithChildren<{
  filtered?: boolean;
  iconProps?: IconProps;
  label?: string;
  tooltip?: string;
}> &
  Pick<ActionIconProps, "loading" | "radius" | "size">;

export const ListTableColumnFilter: FC<ListTableColumnFilterProps> = ({
  children,
  filtered = false,
  iconProps = { size: 24 },
  label,
  tooltip,
  ...props
}) => {
  const Icon = filtered ? IconFilterFilled : IconFilter;
  const c = "dimmed";
  const color = "primary";

  const { colorScheme } = useMantineColorScheme();
  const isDark = colorScheme === "dark";

  return (
    <Menu closeOnItemClick={false} position="bottom-end" shadow="md">
      <Menu.Target>
        <Tooltip
          label={tooltip}
          disabled={tooltip === undefined}
          events={{ hover: true, focus: true, touch: true }}
        >
          <ActionIcon
            c={c}
            color={color}
            variant="subtle"
            size="sm"
            bg={isDark ? "var(--mantine-color-primaryDark-8)" : "inherit"}
            {...props}
          >
            <Icon {...iconProps} />
          </ActionIcon>
        </Tooltip>
      </Menu.Target>
      <Menu.Dropdown p="md">
        {label && <Menu.Label>{label}</Menu.Label>}
        {children}
      </Menu.Dropdown>
    </Menu>
  );
};
